import request from '@/utils/request'

export function SAFE_TOKEN_GET () {
  return request({
    url: '/pub/safe_transfer',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/utils/safe.js